import SessionApi from '@opendoor/shared-fe/build/api/session';
import SessionSaga from '@opendoor/shared-fe/build/store/session/saga';
import { all, fork, takeLatest } from 'redux-saga/effects';

import { COOKIE_KEY } from '../api';
import { WEB_API_URL } from '../helpers/globals';
import sellerFlowSaga from './sellerFlow/saga';

function fixScroll() {
  if (typeof window !== 'undefined') {
    window.scrollTo(0, 0);
  }
}

function* appSaga() {
  yield all([takeLatest('@@router/LOCATION_CHANGE', fixScroll)]);
}

export default function* sagas() {
  yield all([
    fork(appSaga),
    fork(new SessionSaga(new SessionApi(COOKIE_KEY, WEB_API_URL)).saga),
    fork(sellerFlowSaga),
  ]);
}
